import { render, staticRenderFns } from "./CreateSGPoolConfigs.vue?vue&type=template&id=a3bb26c0&scoped=true"
import script from "./CreateSGPoolConfigs.vue?vue&type=script&lang=js"
export * from "./CreateSGPoolConfigs.vue?vue&type=script&lang=js"
import style0 from "./CreateSGPoolConfigs.vue?vue&type=style&index=0&id=a3bb26c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3bb26c0",
  null
  
)

export default component.exports